/*
 * @Description:
 * @Date: 2025-01-22 14:25:48
 */
import { cloneDeep, isObject, isNil, isNaN } from 'lodash';
import { Tree } from '@cTypes/common';

// 适配XrkSlideVerify组件数据格式，其他地方不会用
export const imageJsonTranslator = resp => {
  return {
    data: resp
  };
};
/**
 * @description: 解构带有pager的数据，要求后端统一使用pager
                正常列表数据{ list: [], total: 1}
                有时候需要在list平级添加数据，但是后端必须包一层pager，例
                {
                  amount:111,
                  pager:  {
                      list:[],
                      total:2
                    }
                }
                这种情况解构为
                {
                  list:[],
                  total:2,
                  amount:111
                }
 * @param {*} resp
 * @return {*} resp
 */
export const pagerTranslator = resp => {
  // 应该统一使用pager，但是有的接口使用了page！！！
  const { pager, page, ...options } = resp.data;
  const fkPage = pager || page;
  if (fkPage) {
    resp.data = { ...options, ...fkPage };
  }
  return resp;
};
/**
 * @description: 全局tree结构格式化
 * @param {Array<Record<string, any>>} payload 接口返回结构
 * @return {Tree} 格式后的数据，{label,value,children?,parentId?}
 */
export const treeTranslator = (
  payload: Array<Record<string, any>>,
  fieldsKey?
) => {
  const loop = (
    payload: Array<Record<string, any>>,
    parent,
    fieldsKey?
  ): Tree => {
    const list = cloneDeep(payload);
    list.forEach(item => {
      // 统一label value
      item.label =
        item[fieldsKey?.label] ?? (item.label || item.name || item.dicName);
      item.value = item[fieldsKey?.value] ?? (item.value || item.id);
      // 统一parentId字段
      if (item.fid) {
        item.parentId = item.fid;
      }
      // 无parentId且存在parent对象则填充字段
      if (!item.parentId && parent) {
        item.parentId = parent.value;
      }
      // 统一children字段，删除原始字段，防止数据冗余
      if (item.childrenList) {
        item.children = item.childrenList;
        delete item.childrenList;
      }
      if (item.children && item.children.length) {
        // 用于给子集找parent元素
        // parent = item;
        // 处理子集
        item.children = loop(item.children, item, fieldsKey);
      } else {
        // 删除字段，减少picker组件判断
        delete item.children;
        // 重制父元素
        // parent = null;
      }
    });
    return list as Tree;
  };
  return loop(payload, null, fieldsKey);
};
export const pickerTranslator = (resp, fieldsKey?) => {
  resp.data = treeTranslator(resp.data, fieldsKey);
  return resp;
};
export const map2ArrTranslator = resp => {
  resp.data = Object.keys(resp.data).map(item => ({
    value: item,
    label: resp.data[item]
  }));
  return resp;
};
export const filterEmptyParamsTranslator = (params: Record<string, any>) => {
  if (!isObject) return {};
  const _p = Object.keys(params).reduce((pre, cur) => {
    const cValue = params[cur];
    if (!isNil(cValue) && !isNaN(cValue) && cValue !== '') {
      pre[cur] = cValue;
    }
    return pre;
  }, {});
  return _p;
};

/**
 * @description: 时间段时间转换，由前端自定义个字段映射后端字段
 * @params {Object} params 接口入参
 * @params {Array} backEndFields 后端字段
 * @params {String} frontEndField 前端自定义字段，绑定到了params中，对应的值一定是数组或者null
 */
export const backEndDatetimerangetranslator = (
  params,
  backEndFields = ['startTime', 'endTime'],
  frontEndField = 'time'
) => {
  const _p = params;
  if (isObject(_p)) {
    const _value = _p[frontEndField];
    // 时间组件清空后_frontEndField字段为null
    _p[backEndFields[0]] = _value ? _p[frontEndField]?.[0] || '' : '';
    _p[backEndFields[1]] = _value ? _p[frontEndField]?.[1] || '' : '';
  } else {
    console.error('params is not object');
  }
  return _p;
};
